import { render, staticRenderFns } from "./m-block-goods-scanner.vue?vue&type=template&id=0761b1ad&scoped=true&lang=pug&"
import script from "./m-block-goods-scanner.vue?vue&type=script&lang=js&"
export * from "./m-block-goods-scanner.vue?vue&type=script&lang=js&"
import style0 from "./m-block-goods-scanner.vue?vue&type=style&index=0&id=0761b1ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761b1ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
